export default {
  sortColumns(items, index, isDesc) {
    items.sort((a, b) => {
      if (index[0] == "dateNaissance" || index[0] == "dateDepot") {
        if (!isDesc[0]) {
          return this.dateFr(b[index]) - this.dateFr(a[index]);
        } else {
          return this.dateFr(a[index]) - this.dateFr(b[index]);
        }
      } else if (index[0] == "id") {
        if (!isDesc[0]) {
          return a[index] < b[index];
        } else {
          return b[index] < a[index];
        }
      } else if (index[0] == "etatDemande") {
        if (!isDesc[0]) {
          return a[index].libelle
            .toLowerCase()
            .localeCompare(b[index].libelle.toLowerCase());
        } else {
          return b[index].libelle
            .toLowerCase()
            .localeCompare(a[index].libelle.toLowerCase());
        }
      } else {
        if (typeof a[index] !== "undefined") {
          if (!isDesc[0]) {
            return a[index].toLowerCase().localeCompare(b[index].toLowerCase());
          } else {
            return b[index].toLowerCase().localeCompare(a[index].toLowerCase());
          }
        }
      }
    });
    return items;
  },
  sortScolariteColumns(items, index, isDesc) {
    items.sort((a, b) => {
      if (index[0] == "dateNaissance" || index[0] == "dateDepot") {
        if (!isDesc[0]) {
          return this.dateFr(b[index]) - this.dateFr(a[index]);
        } else {
          return this.dateFr(a[index]) - this.dateFr(b[index]);
        }
      } else if (index[0] == "id") {
        if (!isDesc[0]) {
          return a[index] < b[index];
        } else {
          return b[index] < a[index];
        }
      } else if (index[0] == "etatDemande") {
        if (!isDesc[0]) {
          return this.compareEtatDemande(a, b, index);
        } else {
          return this.compareEtatDemande(b, a, index);
        }
      } else {
        if (typeof a[index] !== "undefined") {
          if (!isDesc[0]) {
            return a[index].toLowerCase().localeCompare(b[index].toLowerCase());
          } else {
            return b[index].toLowerCase().localeCompare(a[index].toLowerCase());
          }
        }
      }
    });
    return items;
  },
  compareEtatDemande(a, b, index) {
    let l1 = a[index].libelle.toLowerCase();
    let l2 = b[index].libelle.toLowerCase();
    let dc1 = this.dateFr(a["dateConfirmation"]);
    let dc2 = this.dateFr(b["dateConfirmation"]);
    let df1 = this.dateFr(a["dateFinalisation"]);
    let df2 = this.dateFr(b["dateFinalisation"]);

    if (l1 != l2) {
      return l1.localeCompare(l2);
    } else if (a["etatDemande"].id === 8) {
      // Confirmée
      return dc1 - dc2;
    } else {
      return df1 - df2;
    }
  },
  /*compareEtatDemande(l1, dc1, df1, l2, dc2, df2) {
    l1 = l1.toLowerCase();
    l2 = l2.toLowerCase();
    dc1 = this.dateFr(dc1);
    dc2 = this.dateFr(dc2);
    df1 = this.dateFr(df1);
    df2 = this.dateFr(df2);

    if (l1 != l2) {
      return l1.localeCompare(l2);
    } else if (l1 == "confirmée par l'étudiant") {
      return dc1 - dc2;
    } else {
      return df1 - df2;
    }
  },*/
  sortEnseignantColumns(items, index, isDesc) {
    items.sort((a, b) => {
      if (index[0] == "dateNaissance" || index[0] == "dateDepot") {
        if (!isDesc[0]) {
          return this.dateFr(b[index]) - this.dateFr(a[index]);
        } else {
          return this.dateFr(a[index]) - this.dateFr(b[index]);
        }
      } else if (index[0] == "id") {
        if (!isDesc[0]) {
          return a[index] < b[index];
        } else {
          return b[index] < a[index];
        }
      } else if (index[0] == "etatDemande") {
        if (!isDesc[0]) {
          return this.compareEtatDemandeEnseignant(a, b, index);
        } else {
          return this.compareEtatDemandeEnseignant(b, a, index);
        }
      } else {
        if (typeof a[index] !== "undefined") {
          if (!isDesc[0]) {
            return a[index].toLowerCase().localeCompare(b[index].toLowerCase());
          } else {
            return b[index].toLowerCase().localeCompare(a[index].toLowerCase());
          }
        }
      }
    });
    return items;
  },
  compareEtatDemandeEnseignant(a, b, index) {
    let l1 = a[index].libelle.toLowerCase();
    let l2 = b[index].libelle.toLowerCase();
    let dd1 = this.dateFr(a["dateDecision"]);
    let dd2 = this.dateFr(b["dateDecision"]);

    if (
      a["etatDemande"].id == b["etatDemande"].id &&
      a["etatDemande"].id === 3
    ) {
      return dd2 - dd1;
    } else if (a["etatDemande"].id === 3) {
      return true;
    } else if (b["etatDemande"].id === 3) {
      return false;
    } else {
      return l1.localeCompare(l2);
    }
  },
  dateFr(dateString) {
    if (dateString == undefined || !dateString || dateString.length === 0) {
      return null;
    }

    var dateParts = dateString.split("/");
    let dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
    return dateObject;
  },
  sortFormationColumns(items, index, isDesc) {
    items.sort((a, b) => {
      if (index[0] == "id") {
        if (!isDesc[0]) {
          return a[index] < b[index];
        } else {
          return b[index] < a[index];
        }
      } else if (index[0] == "eligible") {
        if (!isDesc[0]) {
          return a[index] == true;
        } else {
          return b[index] == true;
        }
      } else if (
        index[0] == "diplome" ||
        index[0] == "niveau" ||
        index[0] == "campus" ||
        index[0] == "structure"
      ) {
        if (!isDesc[0]) {
          return a[index].libelle
            .toLowerCase()
            .localeCompare(b[index].libelle.toLowerCase());
        } else {
          return b[index].libelle
            .toLowerCase()
            .localeCompare(a[index].libelle.toLowerCase());
        }
      } else {
        if (typeof a[index] !== "undefined") {
          if (!isDesc[0]) {
            return a[index].toLowerCase().localeCompare(b[index].toLowerCase());
          } else {
            return b[index].toLowerCase().localeCompare(a[index].toLowerCase());
          }
        }
      }
    });
    return items;
  }
};
